module.exports = __webpack_public_path__ + "media/images/flags/4x3/sau-97b6fd07419ffdbf3751a549dbc03053.svg";